import LoadingAnimationIcon from '@/components/icons/loading-animation-icon';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { cn, isEmpty } from '@/lib/utils';
import { ThemeColorSchemeType } from '@/stores/builder';
import React from 'react';

type ModalAlertProps = {
  title?: string;
  description?: React.ReactNode;
  isLoading?: boolean;
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
  onConfirm?: () => void;
  onCancel?: () => void;
  buttonConfirmText?: string;
  buttonCancelText?: string;
  colorScheme?: ThemeColorSchemeType;
  withQuestionMark?: boolean;
};

export default function ModalAlert({
  title = 'Are you absolutely sure',
  description = 'This action cannot be undone',
  isLoading = false,
  openModal,
  setOpenModal,
  onConfirm,
  onCancel,
  buttonConfirmText = 'Confirm',
  buttonCancelText = 'Cancel',
  colorScheme,
  withQuestionMark = true,
}: ModalAlertProps) {
  return (
    <AlertDialog open={openModal} onOpenChange={setOpenModal}>
      <AlertDialogContent
        className='z-[9999]'
        style={
          {
            '--btn-bg': colorScheme?.btnSolidBackgroud,
            '--btn-label': colorScheme?.btnSolidlabel,
          } as React.CSSProperties
        }
      >
        <AlertDialogHeader>
          <AlertDialogTitle>
            {title}
            {withQuestionMark ? '?' : ''}
          </AlertDialogTitle>
          <AlertDialogDescription className='flex items-start justify-start'>
            {description}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            className='w-full disabled:cursor-not-allowed'
            onClick={onCancel ? onCancel : () => setOpenModal(false)}
            disabled={isLoading}
          >
            {buttonCancelText}
          </AlertDialogCancel>
          <AlertDialogAction
            className={cn(
              'w-full disabled:cursor-not-allowed',
              !isEmpty(colorScheme)
                ? 'bg-[var(--btn-bg)] text-[--btn-label] hover:bg-[var(--btn-bg)] hover:opacity-75'
                : 'bg-primary text-white'
            )}
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading && <LoadingAnimationIcon color='white' />}
            {buttonConfirmText}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
